import React from "react";
import {Button} from "reactstrap";
import { CSVLink } from "react-csv";

const CSVButton = ({ data = [], headers = [], title = "data" }) => (
    <CSVLink
        data={data}
        headers={headers}
        filename={`${title}.csv`}
    >
        <Button
            outline
            color="primary"
            size="sm"
            className="btn-cancel ml-2"
        >
            <i className="fa fa-download" /> CSV
        </Button>
    </CSVLink>
);
export default CSVButton